import { EnumReduces } from "../type";
import { productEndpoints, ProductEnumEndpointsName, TypeProductEndpointsName } from "./product/endpoint";
import { storeEndpoints, StoreEnumEndpointsName, TypeStoreEndpointsName } from "./store/endpoint";

export const endpoints = {
  [EnumReduces.STORE]: storeEndpoints,
  [EnumReduces.PRODUCT]: productEndpoints,
}

export const endpointsName = {
  ...StoreEnumEndpointsName,
  ...ProductEnumEndpointsName
} as const

export type TypeEndpoints = TypeProductEndpointsName | TypeStoreEndpointsName